import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const fieldSchema: CollectionCreateSchema = {
  name: CollectionName.Field,
  enable_nested_fields: true,
  fields: [
    {
      name: "id",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "field_name",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "data_type",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "ap_transfer_section",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "ap_export_section",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "phyto_export_section",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "user_configurable",
      type: "bool",
      sort: true,
    },
    {
      name: "classification_code",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "classification_name",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "field_category",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "default_display_type",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "created_at",
      type: "int64",
      sort: true,
    },
    {
      name: "created_by",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "updated_at",
      type: "int64",
      sort: true,
    },
    {
      name: "updated_by",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
  ],
  visibility: CollectionVisibility.Public,
}
